import { render, staticRenderFns } from "./kohlenhydrate.vue?vue&type=template&id=6cdf891d&"
import script from "./kohlenhydrate.vue?vue&type=script&lang=js&"
export * from "./kohlenhydrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports